import { externalUrls } from 'utils'
import { OptionsDataProps } from '../interface'
// DO NOT USE THIS FILE, youre looking for this one: components/common/elements/Options/utils/optionsData.ts
const optionsData: OptionsDataProps = {
	icd10: {
		about: 'icd10Page.about',
		aboutLink: externalUrls.aboutIcd,
		downloadExcel: externalUrls.downloadExcelIcdTemp,
		api: true,
		report: externalUrls.reportErrorClinical,
	},
	icpc2: {
		about: 'icpc2Page.about',
		aboutLink: externalUrls.aboutIcpc,
		downloadExcel: externalUrls.downloadExcelIcpcTemp,
		api: true,
		report: externalUrls.reportErrorClinical,
	},
	nkpk: {
		about: 'nkpkPage.about',
		aboutLink: externalUrls.aboutNkpk,
		downloadExcel: externalUrls.downloadExcelNkpkTemp,
		api: true,
		report: externalUrls.reportErrorClinical,
	},
	phbu: {
		about: 'phbuPage.about',
		aboutLink: externalUrls.aboutPhbu,
		downloadExcel: externalUrls.downloadExcelPhbuTemp,
		api: true,
		report: externalUrls.reportErrorClinical,
	},
	norpat: {
		about: 'norpatPage.about',
		aboutLink: externalUrls.aboutNorpat,
		api: true,
		report: `mailto:${externalUrls.reportErrorLab}`,
		reportEmail: externalUrls.reportErrorLab,
		hasExcelApiEndpoint: true,
	},
	anatomisk: {
		about: 'general.aboutLab',
		aboutLink: externalUrls.aboutLab,
		api: true,
		report: `mailto:${externalUrls.reportErrorLab}`,
		reportEmail: externalUrls.reportErrorLab,
		hasExcelApiEndpoint: true,
	},
	provemateriale: {
		about: 'general.aboutLab',
		aboutLink: externalUrls.aboutLab,
		api: true,
		report: `mailto:${externalUrls.reportErrorLab}`,
		reportEmail: externalUrls.reportErrorLab,
		hasExcelApiEndpoint: true,
	},
	tekstligeResultatverdier: {
		about: 'general.aboutLab',
		aboutLink: externalUrls.aboutLab,
		api: true,
		report: `mailto:${externalUrls.reportErrorLab}`,
		reportEmail: externalUrls.reportErrorLab,
		hasExcelApiEndpoint: true,
	},
	nlk: {
		about: 'general.aboutLab',
		aboutLink: externalUrls.aboutLab,
		api: true,
		report: `mailto:${externalUrls.reportErrorLab}`,
		reportEmail: externalUrls.reportErrorLab,
		hasExcelApiEndpoint: true,
	},
	undersokelsesmetode: {
		about: 'general.aboutLab',
		aboutLink: externalUrls.aboutLab,
		api: true,
		report: `mailto:${externalUrls.reportErrorLab}`,
		reportEmail: externalUrls.reportErrorLab,
		hasExcelApiEndpoint: true,
	},
	adm: {
		about: 'adminPage.about',
		aboutLink: externalUrls.aboutKis,
		api: true,
		report: `mailto:${externalUrls.reportErrorEmail}`,
		reportEmail: externalUrls.reportErrorEmail,
	},
	snomedct: {
		about: 'snomedctPage.about',
		aboutLink: externalUrls.aboutSnomedct,
		api: true,
		report: externalUrls.reportErrorTerminology,
	},
}

export default optionsData
